import React from 'react';
import { useParams } from 'react-router-dom';

import { Box, Grid } from '@material-ui/core';

import BaseTopBar from 'components/elements/molecules/TopBar';
import ButtonGoBack from 'components/elements/atoms/ButtonGoBack';
import { APP_PATHS } from 'components/routes/paths';

const TopBar = () => {
	const { carId } = useParams();

	return (
		<BaseTopBar
			title="Payment"
			actions={
				<Grid container justify="space-between">
					<Grid item xs="auto">
						<Box pl={1}>
							<ButtonGoBack path={APP_PATHS.CAR.replace(':id', carId)} />
						</Box>
					</Grid>
				</Grid>
			}
		/>
	);
};

export default TopBar;
